import { FormActions } from "../../components/common/FormActions";
import {
  createViewAction,
  formatDate,
  formatDateTime,
  numberFormat,
} from "../../utils/helpers";
import { URL_WEEKLY_WAGES_COLLECTIONS } from "../../utils/urls";
import {
  BooleanTags,
  PaymentStatusTag,
} from "../../components/common/registerUtils";
import dayjs from "dayjs";
import { Link } from "react-router-dom";

const usePayableWages = () => {
  const tableColumns = () => [
    {
      id: "staff_name",
      header: "Staff Name",
      filter: {
        type: "text",
      },
    },
    {
      id: "staff_code",
      header: "Staff Code",
      filter: {
        type: "text",
      },
    },
    {
      id: "staff_type",
      header: "Staff Type",
      filter: {
        type: "text",
      },
    },
    {
      id: "total_collections",
      header: "Total Collections",
    },
    {
      id: "commission_percentage",
      header: "Commission Percentage",
    },
    {
      id: "commission_amount",
      header: "Commission Amount",
    },
    {
      id: "fixed_wage_amount",
      header: "Fixed Wage Amount",
    },
    {
      id: "total_wage",
      header: "Total Wage",
    },
    {
      id: "period_start",
      header: "Period Start",
      filter: {
        type: "date",
      },
    },
    {
      id: "period_end",
      header: "Period End",
      filter: {
        type: "date",
      },
    },
    {
      id: "is_approved",
      header: "Is Approved",
    },
    {
      id: "payment_status",
      header: "Payment Status",
    },
    {
      id: "created_at",
      header: "Created At",
      filter: {
        type: "date",
      },
    },
    {
      id: "created_by",
      header: "Created By",
      filter: {
        type: "text",
      },
    },
    {
      id: "payment",
      header: "Payment",
    },
    {
      id: "actions",
      header: "Actions",
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        is_approved: <BooleanTags status={item?.is_approved} />,
        payment_status: <PaymentStatusTag status={item?.payment_status} />,
        created_at: formatDateTime(item?.created_at),
        created_by: `${item?.created_by?.first_name} ${item?.created_by?.last_name}`,
        payment: (
          <div className="flex gap-2">
            <Link
              className="link-with-icon"
              to={`/pay_wages/create`}
              state={{ item }}
            >
              Make Payment
            </Link>
          </div>
        ),

        actions: (
          <FormActions
            actions={[createViewAction(URL_WEEKLY_WAGES_COLLECTIONS, item?.id)]}
          />
        ),
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Staff & Wage Details",
          fields: {
            "Staff Name": item?.staff_details?.user_full_name,
            "Staff Code": item?.staff_details?.staff_code,
            "Staff Type": item?.staff_details?.staff_type,
            "Phone Number": item?.staff_details?.phone_number,
            Email: item?.staff_details?.user_email,

            "Period Start": formatDate(item?.period_start),
            "Period End": formatDate(item?.period_end),

            "Total Collections": numberFormat(item?.total_collections),
            "Commission %": item?.commission_percentage,
            "Commission Amount": numberFormat(item?.commission_amount),
            "Fixed Wage": numberFormat(item?.fixed_wage_amount),
            "Total Wage": numberFormat(item?.total_wage),

            Approved: <BooleanTags status={item?.is_approved} />,
            "Approved By": item?.approved_by_name,
            "Approved At": formatDateTime(item?.approved_at),
          },
        },
      ],
    };
  };

  const initialFilters = {
    start_date: dayjs().format("YYYY-MM-DD"),
    end_date: dayjs().format("YYYY-MM-DD"),
  };

  const externalFilters = [
    {
      id: "collection_date",
      label: "Collection Date Range",
      type: "date",
      options: [],
    },
  ];

  const tableTitle = "Payable Wages";

  return {
    tableColumns,
    tableData,
    initialFilters,
    externalFilters,
    tableTitle,
    viewData,
  };
};

export default usePayableWages;
